/*
 * Willowdale — sticky add-to-cart bar + scroll-to-top (block: mw_sticky_tools).
 * Lives in an asset (not inline) because the Shopify theme editor does NOT re-run inline
 * scripts when a block setting changes — this file re-initialises on shopify:section:load,
 * so "show after %" etc. apply live in the editor preview.
 */
(function () {
  if (window.__mwStickyTools) return;
  window.__mwStickyTools = true;

  var instances = {};

  function pct() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    return max > 0 ? (window.scrollY / max) * 100 : 0;
  }

  function destroy(bid) {
    var inst = instances[bid];
    if (inst) {
      window.removeEventListener('scroll', inst.onScroll);
      window.removeEventListener('resize', inst.onScroll);
      document.removeEventListener('variant:change', inst.onVariant);
      delete instances[bid];
    }
    document.querySelectorAll('body > [data-mw-sticky-moved="' + bid + '"]').forEach(function (n) { n.remove(); });
    document.documentElement.style.removeProperty('--mw-sticky-h');
  }

  function init(root) {
    var bid = root.getAttribute('data-mw-sticky-tools');
    destroy(bid);

    var bar = root.querySelector('[data-mw-sticky]');
    var top = root.querySelector('[data-mw-totop]');
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mw-st-variants]').textContent); } catch (e) {}

    // Move to <body> so no sticky/transformed product column can trap position:fixed.
    [bar, top].forEach(function (el) {
      if (!el) return;
      el.setAttribute('data-mw-sticky-moved', bid);
      document.body.appendChild(el);
    });

    function mainBtnVisible() {
      var b = form && form.querySelector('[data-add-to-cart]');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
    }
    function setStickyH() {
      var h = bar && bar.classList.contains('is-visible') ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--mw-sticky-h', h + 'px');
    }
    function update() {
      var p = pct();
      if (bar) {
        var on = p >= +bar.getAttribute('data-show-at');
        var hideAt = +bar.getAttribute('data-hide-at');
        if (hideAt < 100 && p >= hideAt) on = false;
        if (bar.getAttribute('data-hide-main') === 'true' && mainBtnVisible()) on = false;
        bar.classList.toggle('is-visible', on);
      }
      if (top) top.classList.toggle('is-visible', p >= +top.getAttribute('data-show-at'));
      setStickyH();
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }

    var inst = instances[bid] = { onScroll: onScroll, onVariant: function () {} };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    if (!bar) return;

    var selects = bar.querySelectorAll('[data-mw-st-option]');
    var addBtn = bar.querySelector('[data-mw-st-add]');
    var qtyInput = bar.querySelector('[data-mw-st-qty-input]');
    var current = null;

    function findVariant() {
      if (!selects.length) return variants[0] || null;
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.every(function (o, j) { return o === opts[j]; })) return variants[i];
      }
      return null;
    }
    function render(v) {
      current = v;
      bar.classList.toggle('is-soldout', !(v && v.available));
      if (v) {
        var price = bar.querySelector('[data-mw-st-price]');
        var cmp = bar.querySelector('[data-mw-st-compare]');
        var img = bar.querySelector('[data-mw-st-img]');
        if (price) price.textContent = v.price;
        if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare; }
        if (img && v.img) img.src = v.img;
      }
      setStickyH();
    }

    // Sticky dropdown -> main picker, so the theme updates gallery, price, URL and the form.
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = sel.getAttribute('data-mw-st-option');
        var synced = false;
        if (form) {
          var scope = form.closest('.product-section, [id^="shopify-section"]') || document;
          scope.querySelectorAll('[data-variant-input][data-index="' + idx + '"]').forEach(function (inp) {
            if (synced) return;
            if (inp.type === 'radio') {
              if (inp.value === sel.value) { if (!inp.checked) inp.click(); synced = true; }
            } else if (inp.tagName === 'SELECT') {
              inp.value = sel.value; inp.dispatchEvent(new Event('change', { bubbles: true })); synced = true;
            }
          });
        }
        if (!synced) render(findVariant());
      });
    });

    // Main picker -> sticky dropdowns.
    inst.onVariant = function (e) {
      var d = e.detail || {};
      if (d.variant && !variants.some(function (x) { return x.id === d.variant.id; })) return;
      if (d.currentlySelectedValues && d.currentlySelectedValues.length) {
        d.currentlySelectedValues.forEach(function (o) {
          var sel = bar.querySelector('[data-mw-st-option="' + o.index + '"]');
          if (sel) sel.value = o.value;
        });
      }
      var v = d.variant ? variants.filter(function (x) { return x.id === d.variant.id; })[0] : findVariant();
      render(v || null);
    };
    document.addEventListener('variant:change', inst.onVariant);

    bar.querySelectorAll('[data-mw-st-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-mw-st-qty'), 10);
        qtyInput.value = Math.max(1, n);
      });
    });

    addBtn.addEventListener('click', function () {
      if (!current || !current.available) return;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var mainBtn = form && form.querySelector('[data-add-to-cart]');
      var idInput = form && form.querySelector('[name="id"]');
      if (mainBtn && idInput && String(idInput.value) === String(current.id)) {
        // Theme's own add-to-cart: cart drawer, loading state, errors, line-item props.
        var q = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + form.id + '"]');
        var temp = false;
        if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); temp = true; }
        var prev = q.value;
        q.value = qty;
        mainBtn.click();
        setTimeout(function () { if (temp) q.remove(); else q.value = prev || 1; }, 0);
        return;
      }
      addBtn.classList.add('is-loading');
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] })
      }).then(function (r) { return r.json(); }).then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }).finally(function () { addBtn.classList.remove('is-loading'); });
    });

    render(findVariant());
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mw-sticky-tools]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor: re-init whenever the product section is re-rendered (any setting change).
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mw-sticky-tools]').forEach(function (r) { destroy(r.getAttribute('data-mw-sticky-tools')); });
  });
})();
